document.addEventListener("DOMContentLoaded", (event) => {

    $status = Array.from(document.getElementsByClassName("event-active-status"));

    if($status[0]){
        console.log($status);
        $status.forEach(
            ($state)=>{

                if($state.innerText == "Bevorstehend" || $state.innerText == "BEVORSTEHEND"){
                    
                    $state.classList.add('hide-notice');
                }
            }

        );
    }

    


});